export {
    performanceManagmentTranslates,
    performanceManagementOptions,
} from './performance-management-translates';
export { creditOfPointTranslates, creditOfPointOptions } from './credit-of-point-translates';
export { Interest, interestTranslates, interestOptions } from './interest-translates';
export {
    SportCategory,
    sportCategoryTranslates,
    sportCategoryOptions,
} from './sport-category-translates';
export {
    PreferToCommunicate,
    preferToCommunicateTranslates,
} from './prefer-to-communicate-translates';
export { NeedToControlled, needToControlledTranslates } from './need-to-controlled-translates';
export { onlineApplicationStatusTranslates } from './online-application-translates';
export { additionalNoteTranslates, additionalNoteEntries } from './additional-note';
